<template>
  <div id="orderlist" style="width: 100%;height: 100%">
    <el-row>
      <el-col>
        <el-form :inline="true" :model="筛选表单" ref="筛选表单" class="demo-form-inline">
          <el-form-item label="团餐公司：">
            <el-select size="medium" v-model="筛选表单.团餐公司" filterable placeholder="请选择" clearable @change="queryPROJECT()">
              <el-option v-for="item in companys" :key="item.value" :label="item.AB_NAME" :value="item.ID"  ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：">
            <el-select size="medium" filterable v-model="筛选表单.项目点"  placeholder="请选择" clearable
                       @change="querydkList">
              <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="档口：">
            <el-select size="medium" filterable v-model="筛选表单.档口"  placeholder="请选择" clearable>
              <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="送货日期范围：">
            <el-date-picker v-model="筛选表单.日期范围" type="daterange" align="right" unlink-panels
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            value-format="yyyy-MM-dd" :clearable="false" ></el-date-picker>
          </el-form-item>
          <el-form-item label="销售订单ID：">
            <el-input size="medium" v-model="筛选表单.销售订单ID" style="width: 180px;" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" id="search" @click="handleSearch()">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col :span="24">
        <el-table :data="tableData"  border stripe  style="width: 100%">
          <el-table-column prop="ORDER_ID" label="销售订单ID" width="100"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
          <el-table-column prop="TC_NAME" label="客户名称"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点名称"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口名称"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="BRAND" label="品牌"></el-table-column>
          <el-table-column prop="SHORT_NAME" label="品名"></el-table-column>
          <el-table-column prop="SPECIFICATION" label="规格"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="送货数量"></el-table-column>
          <el-table-column prop="确认送货数量" label="确认送货数量">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="24">
                  <el-input size="small" :placeholder="scope.row.PRODUCT_COUNT" v-model="scope.row.确认送货数量" clearable></el-input>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
                       layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <el-row >
      <el-button size="small"  @click="确认订单()" type="primary">确认订单</el-button>
    </el-row>
  </div>
</template>
<script>
import {
  DSOrderFun, changeStatusFun, queryCustomerFun, haveSupplierFun,
} from '@/assets/api/DSOrder';
import {
  selectProjectFun, batchExportFun, getHaveSupplyRelationshipProjectList, selectTCFun,
} from '@/assets/api/sellOrder';
import date from '@/assets/common/date';
import { frontEndFun } from '@/assets/api/frontFun';
import http from '@/assets/common/http';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      PAGE_ID: '10016', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1001601: 0 }, // 功能ID 一旦规定不要轻易改动
      loading1: false,
      companys: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 15,


      筛选表单: {
        日期范围: [date(new Date(), '%F'), date(new Date(), '%F')],
      },
      tableData: [],
      supplierList: [],
      points: [],
      dkList: [],
    };
  },
  computed: {
    // 上一次的搜索结果和条件
    DS_ORDER_LIST_CONDITION() {
      return this.$store.state.DS_ORDER_LIST_CONDITION;
    },
  },
  created() {
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryCustomer();
    // if (this.DS_ORDER_LIST_CONDITION.CONDITION) {
    //   this.筛选表单 = this.DS_ORDER_LIST_CONDITION.CONDITION;
    //   this.currentPage = this.DS_ORDER_LIST_CONDITION.CURRENT_PAGE;
    // }
    // if (this.筛选表单.PROJECT_ID && this.筛选表单.PROJECT_ID.length !== 0) {
    //   this.queryDkList();
    // }
    this.queryData();
  },
  methods: {
    确认订单() {
      const submitArr = this.tableData.map((item, index) => ({
        DETAIL_ID: Number(item.DETAIL_ID),
        NEED_COUNT: item.确认送货数量,
      }));
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 101,
        DETAIL_LIST: submitArr,
      };
      http.post(params).then((result) => {
        this.$message.show({
          text: '更新成功',
          type: 'success',
        });
        this.queryData();
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    queryCustomer() {
      const params = {};
      selectTCFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.companys = result[0].company;
          } else {
            this.companys = [];
          }
        }).catch((error) => {
        });
    },
    // 选取客户 拉取对应项目点
    queryPROJECT() {
      if (!this.筛选表单.团餐公司) {
        this.筛选表单.项目点 = '';
        this.筛选表单.档口 = '';
        return false;
      }
      this.筛选表单.项目点 = '';
      const paramsProject = {
        TC_ID: this.筛选表单.团餐公司,
      };
      getHaveSupplyRelationshipProjectList(paramsProject).then((result) => {
        if (result[0]) {
          this.points = result;
        } else {
          this.points = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySupplier() {
      const params = {};
      if (this.筛选表单.SUPPLIER) {
        params.SUPPLIER_NAME = this.筛选表单.SUPPLIER;
      }
      haveSupplierFun()
        .then((result) => {
          this.supplierList = result.length > 0 ? result : [];
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 改变项目点 拉取档口
    // ----------------------------------------------下拉框获取档口名称
    querydkList() {
      if (!this.筛选表单.项目点) {
        this.dkList = [];
        this.筛选表单.档口 = '';
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.筛选表单.项目点) {
        params.PROJECTS_ID = [this.筛选表单.项目点];
      } else {
        this.dkList = [];
        return false;
      }
      http.post(params).then((result) => {
        this.dkList = result;
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },

    handleSearch() {
      this.currentPage = 1;
      this.queryData();
    },
    // -----------------------获取新订单列表
    queryData() {
      if ((new Date(this.筛选表单.日期范围[1]) - new Date(this.筛选表单.日期范围[0])) / 86400000 > 7) {
        this.$message.show({ text: '选择的日期范围请不要大于7天', type: 'warning' });
        return;
      }
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        START_DAY: this.筛选表单.日期范围[0],
        END_DAY: this.筛选表单.日期范围[1],
        SERVICE_ID: '10009',
        OTYPE: 100,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.筛选表单.团餐公司) {
        params.TC_ID = this.筛选表单.团餐公司;
      }
      if (this.筛选表单.项目点) {
        params.PROJECT_ID = this.筛选表单.项目点;
      }
      if (this.筛选表单.销售订单ID) {
        params.ORDER_ID = this.筛选表单.销售订单ID;
      }
      if (this.筛选表单.团餐公司) {
        params.TC_ID = this.筛选表单.团餐公司;
      }
      if (this.筛选表单.档口) {
        params.DK_ID = this.筛选表单.档口;
      }
      http.post(params).then((result) => {
        if (result != []) {
          this.tableData = result[0].OP_ROLE.map((item) => ({
            ...item,
            确认送货数量: item.PRODUCT_COUNT,
          }));
          this.totalCount = result[0].TOTAL_COUNT;
          // this.$store.dispatch('SET_DS_ORDER_LIST_CONDITION', {
          //   CONDITION: this.筛选表单,
          //   CURRENT_PAGE: this.currentPage,
          // });
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange() {
      this.queryData();
    },
  },
};
</script>
<style scoped>
.el-button--text {
  margin: 0 0 0 10px
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/NoActualOrderConfirmation.vue